import React from "react";
import Card from "../Card/Card";
import useFetch from "../../hooks/useFetch";

const List = ({ subCats, maxPrice, sort, catId }) => {
  let valsort = ``;
  if (sort != null) {
    valsort = `&sortprice=${sort}`;
  }
  const { data, loading, error } = useFetch(
    `/products?populate=*&categories=${catId}${subCats.map(
      (item) => `&sub_categories=${item}`
    )}&maxprice=${maxPrice}${valsort}`, 'NoToken'
  );

  return (
    <>
      <div className="row">
        {loading
          ? "loading"
          : data?.map((item) => <Card item={item} key={item.id} />)}
      </div>
      <div className="row" style={{display: "none"}}>
        <ul className="pagination pagination-lg justify-content-end">
          <li className="page-item disabled">
              <a className="page-link active rounded-0 mr-3 shadow-sm border-top-0 border-left-0" href="#" tabIndex="-1">1</a>
          </li>
          <li className="page-item">
              <a className="page-link rounded-0 mr-3 shadow-sm border-top-0 border-left-0 text-dark" href="#">2</a>
          </li>
          <li className="page-item">
              <a className="page-link rounded-0 shadow-sm border-top-0 border-left-0 text-dark" href="#">3</a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default List;
